import { Entity, Field } from "typegraph";

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: string;
	
	@Field()
	public externalId: string;
	
	@Field()
	public name: string;
	
	@Field()
	public smallIconURL: string;
	
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/entities/Product.ts